import { useMutation, useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./Review.gql";
import { useToasts } from "react-toast-notifications";

export const useAddReview = () => {
  const { addReview } = DEFAULT_OPERATIONS;
  const { addToast } = useToasts();

  const [AddReview, { called, data: ReviewData, error: errorReview }] =
    useMutation(addReview, {
      onCompleted: () => {
        addToast("Review was Submitted Successfully.", {
          appearance: "success",
          autoDismiss: true,
          style: {
            backgroundColor: "#027B51" /* Custom background color */,
            color: "#fff" /* Custom text color */,
          },
        });
      },
    });

  return {
    AddReview,
  };
};
